import { Inject, Injectable } from "@angular/core";
import { createEffect } from "@ngrx/effects";
import { DEFAULT_PAGE_CONTENT_TYPE, DocumentMetaAction, MetaFields, PageAction } from "@obg/ngx.core";
import { EventBusFacade } from "remote-module-context";
import { filter, map } from "rxjs/operators";

import { T_SHELL_EVENT_BUS_FACADE } from "../injection";
import { observeEvent } from "../util/observe-event";

@Injectable({
	providedIn: "root",
})
export class PageEffects {
	updateMataDataByKeys$ = createEffect(() =>
		observeEvent<{ keys: string[] }>(this.eventBus, "updateMataDataByKeys").pipe(
			filter(({ keys }) => !!keys.length),
			map(({ keys }) => {
				const [segment, ...parentSegments] = keys.map((key) => ({
					providerId: DEFAULT_PAGE_CONTENT_TYPE,
					key,
				}));
				return PageAction.setByDocumentKey({ segment, parentSegments });
			})
		)
	);

	setMetaTags$ = createEffect(() =>
		observeEvent<{ metaFields: MetaFields }>(this.eventBus, "setMetaTags").pipe(
			map(({ metaFields }) => this.documentMetaAction.setMetaData(metaFields))
		)
	);

	constructor(
		@Inject(T_SHELL_EVENT_BUS_FACADE) private eventBus: EventBusFacade,
		private documentMetaAction: DocumentMetaAction
	) {}
}
